import { module } from 'angular';
import App from '../../../app';

class SCR1702Controller {
	
	constructor ($scope, $state, $timeout, $uibModalInstance, httpService, utilService, gridService, popupService, data){
		this.$scope = $scope;
		this.$state = $state;
		this.$uibModalInstance = $uibModalInstance;
		this.$timeout = $timeout;
		this.httpService = httpService;
		this.utilService = utilService;
		this.gridService = gridService;
		this.popupService = popupService;
		this.data = data;
		
		this.initWindow(720, 640);
		this.initText();
		this.initSearch();
		this.initSelect();
		
		this.$timeout(() => {
			this.setGridHeight();
			this.initBizCdGridOption();
			this.getBizCodes();
		});
	}
	
	initWindow(width, height){
		const { top, left } = this.popupService.calculatePosition(width,height);
		
		this.width = width;
		this.height = height;
		this.top = top;
		this.left = left;
		this.zIndex = this.popupService.getModalZIndex();
	}
	
	initText(){
		this.text = {
			bizCdSearch : bxMsg('manageBizCode.bizCdSearch'),
			bizCd : bxMsg('manageBizCode.bizCd'),
			bizCdNm : bxMsg('manageBizCode.bizCdNm'),
			bizCdDesc : bxMsg('manageBizCode.bizCdDesc'),
			select : bxMsg('common.select'),
			cancel : bxMsg('common.cancel'),
			search : bxMsg('common.search'),
			resetSearch : bxMsg('common.resetSearch')
		};
	}
	
	initSearch(){
		this.searchParam = {};
	}
	
	initSelect(){
		this.select = this.gridService.getSelect(10);
	}
	
	initBizCdGridOption(){
		this.gridView = new RealGridJS.GridView('grid');
		this.gridView.setCheckBar({visible: false});
		this.gridView.setDisplayOptions({fitStyle: 'evenFill'}); 
		
		this.dataProvider = new RealGridJS.LocalDataProvider();
		this.gridView.setDataSource(this.dataProvider);		
		this.gridService.setDefaultSetting(this.gridView);
		
		this.dataProvider.setFields([
            {
            	fieldName: "no",
            	calculateCallback: (dataRow, fieldName, fieldNames, values) => {
            		return this.gridService.getNoField(this.select.pageSize, dataRow, this.pageNumber);
        		}
    		}, 
    		 {fieldName: "bizCd"}, {fieldName: "bizCdNm"}, {fieldName: "bizCdDesc"}
        ]);
		
		this.gridView.setColumns([
			{ name: "no", fieldName: "no", header : { text: "no" } , width: 40, styles: { textAlignment: 'center' } },
			{ name: "bizCd", fieldName: "bizCd", header : { text: this.text.bizCd }, width: 100, styles: { textAlignment: 'center' } },
			{ name: "bizCdNm", fieldName: "bizCdNm", header : { text: this.text.bizCdNm }, width: 100, styles: { textWrap: 'ellipse' } },
			{ name: "bizCdDesc", fieldName: "bizCdDesc", header : { text: this.text.bizCdDesc }, width: 100, styles: { textWrap: 'ellipse' } }
		]);
		
		this.gridView.onDataCellDblClicked = (grid, cell) => {
			this.closeModal(true)
		};
	}
	
	getBizCodes(goToFirst = false) {
		const {pageNumber, pageSize} = this.getPageInfo();
		let url = `/bizs?pageNumber=${ goToFirst ? 1 : pageNumber}&pageSize=${pageSize}`;
		
		this.httpService.get(url, this.searchParam).then(data => {
			if(goToFirst) {
				this.pageNumber = 1;
				this.$scope.$broadcast(`resetPage`, this.pageNumber);
			}
			
			this.recordsCount = data.totalCnt;
			this.dataProvider.setRows(data.bizcdOutList);
		});
	}
	
	getPageInfo() {
		return {
			pageNumber: this.pageNumber || 1,
			pageSize: this.select.pageSize
		};
	}
	
	resetSearch(){
		this.searchParam = {};
		this.getBizCodes(true);
	}
	
	search(){
		this.getBizCodes(true);
	}
	
	blur($event){
		$event.target.blur();
	}
	
	pageBtnClick(num){
		this.pageNumber = num;
		this.getBizCodes(num === 1);
	}
	
	closeModal(isOk){
		if(isOk){
			const selection = this.gridView.getSelectedRows();
			
			if(selection.length === 0){
				this.$uibModalInstance.dismiss();
			} else {
				this.$uibModalInstance.close(this.gridView.getValues(selection[0]));
			}
		} else {
			this.$uibModalInstance.dismiss();
		}
		
		this.gridView.destroy();
		this.dataProvider.destroy();
	}
	
	setGridHeight() {
		let $msgGrid = $('#grid');
		let height = this.gridService.getGridHeight(this.select.pageSize);
		
		$msgGrid.height(height);
	}
	
}

module(App.name).controller('SCR1702Controller', SCR1702Controller);




// WEBPACK FOOTER //
// ./src/app/views/popup/SCR1702/SCR1702.controller.js